import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inicio from './pages/Inicio';
import Ayuda from './pages/Ayuda';
import Cuentas from './pages/Cuentas';
import Movimientos from './pages/Movimientos';
import TasasCambio from './pages/TasasCambio';
import Conciliacion from './pages/Conciliacion';
import Auditoria from './pages/Auditoria';
import Configuracion from './pages/Configuracion';
import Administracion from './pages/Administracion';
import Ventas from './pages/Ventas';
import CajaVenta from './pages/CajaVenta';
import CajaConfiguracion from './pages/CajaConfiguracion';
import CajaResumen from './pages/CajaResumen';
import Productos from './pages/Productos';
import ProductosCategorizar from './pages/ProductosCategorizar';
import Proveedores from './pages/Proveedores';
import FacturasRecurrentes from './pages/FacturasRecurrentes';
import ComparadorPrecios from './pages/ComparadorPrecios';
import InventarioCierre from './pages/InventarioCierre';
import InventarioActual from './pages/InventarioActual';
import EstructuraCostoGrupos from './pages/EstructuraCostoGrupos';
import SimulacionCosto from './pages/SimulacionCosto';
import EstructuraCosto from './pages/EstructuraCosto';
import ListaPrecios from './pages/ListaPrecios';
import PantallaPestanas from './components/PantallaPestanas';
import Categorias from './pages/Categorias';
import PlanCuentas from './pages/PlanCuentas';
import ConfiguracionContable from './pages/ConfiguracionContable';
import Clientes from './pages/Clientes';
import Vendedores from './pages/Vendedores';
import VendedorDetalle from './pages/VendedorDetalle';
import FacturaVentaForm from './pages/FacturaVentaForm';
import ReporteCuentasPorPagar from './pages/ReporteCuentasPorPagar';
import ReporteEgresosCategoria from './pages/ReporteEgresosCategoria';
import ReporteFlujoCaja from './pages/ReporteFlujoCaja';
import ReporteFlujoProyectado from './pages/ReporteFlujoProyectado';
import ReporteActividadUsuario from './pages/ReporteActividadUsuario';
import ReporteMovimientosControl from './pages/ReporteMovimientosControl';
import CierrePeriodo from './pages/CierrePeriodo';
import ReporteCuentasPorCobrar from './pages/ReporteCuentasPorCobrar';
import ReporteAntiguedadPorPagar from './pages/ReporteAntiguedadPorPagar';
import ReporteAntiguedadPorCobrar from './pages/ReporteAntiguedadPorCobrar';
import Impuestos from './pages/Impuestos';
import CierreFiscalDiario from './pages/CierreFiscalDiario';
import EstadoResultados from './pages/EstadoResultados';
import BalanceGeneral from './pages/BalanceGeneral';
import Produccion from './pages/Produccion';
import ProduccionForm from './pages/ProduccionForm';
import ProduccionEstimaciones from './pages/ProduccionEstimaciones';
import Reportes from './pages/Reportes';
import ReporteCostoActividades from './pages/ReporteCostoActividades';
import BarraInferior from './components/BarraInferior';

const PESTANAS_PRODUCTOS = [
  { ruta: '/productos', label: 'Productos', componente: Productos },
  { ruta: '/productos/categorizar', label: 'Categorizar', componente: ProductosCategorizar }
];
const PESTANAS_COSTOS = [
  { ruta: '/inventario/estructura-costo', label: 'Estructura de costo', componente: EstructuraCosto },
  { ruta: '/inventario/lista-precios', label: 'Lista de precios', componente: ListaPrecios }
];


function Layout({ children }) {
  const [sidebarAbierta, setSidebarAbierta] = useState(false);

  return (
    <div className="flex h-screen print:h-auto print:block">
      <Sidebar abierta={sidebarAbierta} onCerrar={() => setSidebarAbierta(false)} />
      <div className="flex-1 flex flex-col overflow-hidden print:overflow-visible">
        <Topbar onAbrirMenu={() => setSidebarAbierta(true)} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 pb-24 sm:pb-24 md:pb-6 print:overflow-visible print:p-0">
          {children}
        </main>
      </div>
      <BarraInferior onAbrirMenu={() => setSidebarAbierta(true)} />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Manual de usuario (#129): sin menú, porque se abre en otra pestaña
          desde el botón (?) de cada pantalla. */}
      <Route
        path="/ayuda"
        element={
          <ProtectedRoute>
            <Ayuda />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout><Inicio /></Layout>
          </ProtectedRoute>
        }
      />
      {/* El Dashboard de siempre (gráficos y últimos movimientos), ahora
          Bancos → Resumen; "/" es la pantalla Inicio. */}
      <Route
        path="/bancos/resumen"
        element={
          <ProtectedRoute seccion="dashboard">
            <Layout><Dashboard /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cuentas"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="cuentas">
            <Layout><Cuentas /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/movimientos"
        element={
          <ProtectedRoute rolMinimo="operador" seccion="movimientos">
            <Layout><Movimientos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/conciliacion"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><Conciliacion /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categorias"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><Categorias /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/contabilidad/plan-cuentas"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><PlanCuentas /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/contabilidad/configuracion"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><ConfiguracionContable /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasas-cambio"
        element={
          <ProtectedRoute rolMinimo="operador" seccion="tasas_cambio">
            <Layout><TasasCambio /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/auditoria"
        element={
          <ProtectedRoute rolMinimo="gerente" seccion="auditoria">
            <Layout><Auditoria /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracion"
        element={
          <ProtectedRoute rolMinimo="gerente" seccion="configuracion">
            <Layout><Configuracion /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/administracion"
        element={
          <ProtectedRoute soloAdminGlobal>
            <Layout><Administracion /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ventas"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="ventas">
            <Layout><Ventas /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="ventas">
            <Layout><Clientes /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendedores"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="ventas">
            <Layout><Vendedores /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendedores/:id"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="ventas">
            <Layout><VendedorDetalle /></Layout>
          </ProtectedRoute>
        }
      />
      {/* Carga de factura de venta a pantalla completa (#34): nueva, edición
          y notas de crédito/débito sobre una factura anterior. */}
      {[
        '/clientes/:clienteId/factura/nueva',
        '/clientes/:clienteId/factura/:facturaId',
        '/clientes/:clienteId/nota/:tipo/:afectadaId'
      ].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute rolMinimo="operador" modulo="ventas">
              <Layout><FacturaVentaForm /></Layout>
            </ProtectedRoute>
          }
        />
      ))}
      <Route
        path="/caja"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="caja">
            <Layout><CajaVenta /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caja/resumen"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="caja">
            <Layout><CajaResumen /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caja/configuracion"
        element={
          <ProtectedRoute rolMinimo="gerente" modulo="caja">
            <Layout><CajaConfiguracion /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/productos"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><PantallaPestanas titulo="Productos" pestanas={PESTANAS_PRODUCTOS} /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/productos/categorizar"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><PantallaPestanas titulo="Productos" pestanas={PESTANAS_PRODUCTOS} /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/proveedores"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="proveedores">
            <Layout><Proveedores /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/proveedores/recurrentes"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="proveedores">
            <Layout><FacturasRecurrentes /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/proveedores/comparador-precios"
        element={
          <ProtectedRoute rolMinimo="consultor" modulo="proveedores">
            <Layout><ComparadorPrecios /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/costo-actividades"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><ReporteCostoActividades /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/actual"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><InventarioActual /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/cierre"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><InventarioCierre /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/estructura-costo"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><PantallaPestanas titulo="Costos y precios" pestanas={PESTANAS_COSTOS} /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/grupos-costo"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><EstructuraCostoGrupos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/simulacion"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><SimulacionCosto /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventario/lista-precios"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="productos">
            <Layout><PantallaPestanas titulo="Costos y precios" pestanas={PESTANAS_COSTOS} /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes"
        element={
          <ProtectedRoute rolMinimo="consultor">
            <Layout><Reportes /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/flujo-caja"
        element={
          <ProtectedRoute rolMinimo="consultor">
            <Layout><ReporteFlujoCaja /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/flujo-proyectado"
        element={
          <ProtectedRoute rolMinimo="consultor">
            <Layout><ReporteFlujoProyectado /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/movimientos-inusuales"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><ReporteMovimientosControl /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/actividad-usuario"
        element={
          <ProtectedRoute rolMinimo="gerente" seccion="auditoria">
            <Layout><ReporteActividadUsuario /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/egresos-categoria"
        element={
          <ProtectedRoute rolMinimo="consultor">
            <Layout><ReporteEgresosCategoria /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/cuentas-por-pagar"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_cxp">
            <Layout><ReporteCuentasPorPagar /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/antiguedad-por-pagar"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_cxp">
            <Layout><ReporteAntiguedadPorPagar /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/antiguedad-por-cobrar"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_cxc">
            <Layout><ReporteAntiguedadPorCobrar /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/cuentas-por-cobrar"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_cxc">
            <Layout><ReporteCuentasPorCobrar /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/impuestos"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_libro_fiscal">
            <Layout><Impuestos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/libro-ventas"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_libro_fiscal">
            <Layout><Impuestos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/libro-compras"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_libro_fiscal">
            <Layout><Impuestos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/retenciones"
        element={
          <ProtectedRoute rolMinimo="contador" modulo="reporte_libro_fiscal">
            <Layout><Impuestos /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/cierre-fiscal-diario"
        element={
          <ProtectedRoute rolMinimo="operador" modulo="caja">
            <Layout><CierreFiscalDiario /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/cierre"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><CierrePeriodo /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/estado-resultados"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><EstadoResultados /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes/balance-general"
        element={
          <ProtectedRoute rolMinimo="contador" seccion="movimientos">
            <Layout><BalanceGeneral /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/produccion"
        element={
          <ProtectedRoute seccion="produccion" modulo="produccion_extrusion">
            <Layout><Produccion /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/produccion/cargar"
        element={
          <ProtectedRoute seccion="produccion" modulo="produccion_extrusion" rolMinimo="operador">
            <Layout><ProduccionForm /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/produccion/estimaciones"
        element={
          <ProtectedRoute seccion="produccion" modulo="produccion_extrusion">
            <Layout><ProduccionEstimaciones /></Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
